import { getApiError } from '~/api/problem'
import { FinanceErrorType } from '../errors'

const MESSAGES: Record<FinanceErrorType, string> = {
  [FinanceErrorType.InvoicePaidImmutable]:
    'Une facture partiellement ou totalement réglée ne peut être modifiée, sauf les champs "Commentaire client", "Montant réglé", "Date de règlement" et "Date d\'échéance"',
  [FinanceErrorType.InvoicePaidAmountExceedsTotal]:
    'Le montant réglé doit être du même signe que le total TTC et ne peut pas le dépasser'
}

const isFinanceErrorType = (type: string): type is FinanceErrorType =>
  type in MESSAGES

export const getInvoiceErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  const type = getApiError(error)?.type

  return type && isFinanceErrorType(type) ? MESSAGES[type] : fallback
}
